import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { preVettingApi } from "@/lib/api/preVetting";
import type { PreVettingDraft } from "@chinese-vendor/schemas";

export const PRE_VETTING_DRAFT_KEY = ["preVettingDraft"] as const;

export function usePreVettingDraft() {
  const queryClient = useQueryClient();

  const draftQuery = useQuery({
    queryKey: PRE_VETTING_DRAFT_KEY,
    queryFn: async () => {
      try {
        return await preVettingApi.getDraft();
      } catch {
        // No draft yet — treat as empty
        return null;
      }
    },
    staleTime: Infinity, // draft doesn't change outside this session
  });

  const saveDraftMutation = useMutation({
    mutationFn: (draft: PreVettingDraft) => preVettingApi.saveDraft(draft),
    onSuccess: (_, savedDraft) => {
      queryClient.setQueryData(PRE_VETTING_DRAFT_KEY, (prev: PreVettingDraft | null) => ({
        ...prev,
        ...savedDraft,
      }));
    },
  });

  return { draftQuery, saveDraftMutation };
}
